import ModalHistory from './master-modal.history.component'

export default ModalHistory
